import React from 'react'
import { Table } from 'antd';
import type { TableProps } from 'antd';

interface DataType {
    key: string;
    name: string;
    score: number;
    location: string;
    url: string;
    time: string;
}

// In the fifth row, other columns are merged into first column
// by setting it's colSpan to be 0
// const sharedOnCell = (_: DataType, index?: number) => {
//     if (index === 1) {
//         return { colSpan: 0 };
//     }

//     return {};
// };

const columns: TableProps<DataType>['columns'] = [
    {
        title: 'No',
        dataIndex: 'key',
        rowScope: 'row',
    },
    {
        title: 'Report Name',
        dataIndex: 'name',
        // filterSearch: true,
        // render: (text) => <a>{text}</a>,
        // onCell: (_, index) => ({
        //     colSpan: index === 1 ? 5 : 1,
        // }),
    },
    {
        title: 'Avg Score',
        dataIndex: 'score',
        // onCell: sharedOnCell,
    },
    {
        title: 'Location',
        // colSpan: 2,
        dataIndex: 'location',
        // onCell: (_, index) => {
        //     if (index === 3) {
        //         return { rowSpan: 2 };
        //     }
        //     // These two are merged into above cell
        //     if (index === 4) {
        //         return { rowSpan: 0 };
        //     }
        //     if (index === 1) {
        //         return { colSpan: 0 };
        //     }

        //     return {};
        // },
    },
    {
        title: 'URL',
        // colSpan: 0,
        dataIndex: 'url',
        render: (data) => {
            console.log(data);
            return (<a>PDF</a>);
        }
        // onCell: sharedOnCell,
    },
    {
        title: 'Date Time',
        dataIndex: 'time',
        // onCell: sharedOnCell,
    },
];

const data: DataType[] = [
    {
        key: '1',
        name: 'ES002FG3',
        score: 10,
        location: 'ES Industrial Park Demo / ES 001 / 2nd floor / Gallery 3',
        url: '#',
        time: '2024.08.10 10:49',
    },
    {
        key: '2',
        name: 'ES002FG3',
        score: 10,
        location: 'ES Industrial Park Demo / ES 001 / 2nd floor / Gallery 3',
        url: '#',
        time: '2024.08.10 10:49',
    },
    {
        key: '3',
        name: 'ES002FG3',
        score: 10,
        location: 'ES Industrial Park Demo / ES 001 / 2nd floor / Gallery 3',
        url: '#',
        time: '2024.08.10 10:49',
    },
    {
        key: '4',
        name: 'ES002FG3',
        score: 10,
        location: 'ES Industrial Park Demo / ES 001 / 2nd floor / Gallery 3',
        url: '#',
        time: '2024.08.10 10:49',
    },
];

const ReportsPage = () => {

    return (<div className='p-2'>
        <h3 className='mb-4 mt-2'>REPORTS</h3>
        <Table<DataType>
            columns={columns}
            dataSource={data}
            onChange={(val)=>{

            }}
            showSorterTooltip={{ target: 'sorter-icon' }}
            // headerColor={"#212121"}
            
        />
    </div>)
}

export default ReportsPage;